import { useContext } from "react";

import { ConfigurationContext } from "../ConfigurationContext";

/**
 * useCoreFeature provides access to feature toggles from the ConfigurationContext.
 * Returns a boolean indicating whether the specified feature is enabled.
 * Gracefully handles missing context or feature configurations.
 *
 * @param {string} featureName - Name of the feature to check.
 * @returns {boolean} True if the feature is enabled, false otherwise
 */

export const useCoreFeature = (featureName) => {
  const configuration = useContext(ConfigurationContext);
  const coreFeatures = configuration?.coreFeatures;

  return coreFeatures?.[featureName] ?? false;
};
